import { useEffect, useState } from "react";
import apiCalls from "src/api/apiCalls";
const useApi = () => {
    const [awaitingResponse, setAwaitingResponse] = useState({});
    const [data, setData] = useState({});
    const [error, setError] = useState({});
    useEffect(() => {
        return () => {
            cleanState()
        }
    }, [])
    const cleanState = () => {
        setAwaitingResponse({})
        setData({})
        setError({})
    }
    const handleApi = async (fetchMethod, fetchDetails, dataFor, hasFetchParams, fetchParams,shouldClear) => {
        if(shouldClear){
            cleanState();
        }
        if (!dataFor) {
            return;
        }
        const handleMethod = async () => {
            const response = hasFetchParams ? await fetchMethod(...fetchParams) : await fetchMethod()
            if (response.ok) {
                setData((prev) => ({ ...prev, [dataFor]: response.data }));
            } else {
                setError((prev) => ({ ...prev, [dataFor]: apiCalls.isErrorDispaly(response) }));
            }
        }
        const handleFetch = async () => {
            const response = fetchDetails.options ? await fetch(fetchDetails.url, fetchDetails.options) : await fetch(fetchDetails.url);
            const responseData = await response.json();
            if (response.ok) {
                setData((prev) => ({ ...prev, [dataFor]: responseData }));
            } else {
                setError((prev) => ({ ...prev, [dataFor]: apiCalls.isErrorDispaly(responseData) }));
            }
        }
        setAwaitingResponse((prev) => ({ ...prev, [dataFor]: true }));
        try {
            if (fetchMethod && !fetchDetails) {
                await handleMethod()
            }
            if (!fetchMethod && fetchDetails) {
                await handleFetch()
            }
        } catch (error) {
            setError({ [dataFor]: error?.message || error.toString() });
        } finally {
            setAwaitingResponse((prev) => ({ ...prev, [dataFor]: false }));
        }
    };
    return { awaitingResponse, data, error, handleApi };
};
export default useApi